import { type StateValidator } from "@utils/state-validation.utils";

import { Service } from "@angular/core";

const STORAGE_KEY = "oct-web-iot:state";

@Service()
export class StatePersistenceService {
  private readonly persistedState = this.readPersistedState();

  read<T>(slice: string, defaults: T, validator?: StateValidator): T {
    const value = this.persistedState[slice];
    if (value === undefined) return defaults;
    if (validator && !validator(value)) {
      console.error(`Unable to hydrate application state slice "${slice}"`);
      return defaults;
    }
    return value as T;
  }

  write<T>(slice: string, value: T) {
    this.persistedState[slice] = value;

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.persistedState));
    } catch (error) {
      console.error("Unable to persist application state", error);
    }
  }

  private readPersistedState(): Record<string, unknown> {
    try {
      const value = localStorage.getItem(STORAGE_KEY);
      if (!value) return {};

      const parsed: unknown = JSON.parse(value);
      return parsed !== null &&
        typeof parsed === "object" &&
        !Array.isArray(parsed)
        ? (parsed as Record<string, unknown>)
        : {};
    } catch (error) {
      console.error("Unable to hydrate application state", error);
      return {};
    }
  }
}
